import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import React from 'react'
import { Placement } from 'react-bootstrap/types'

export function withTooltip(
    item: JSX.Element,
    toolTipText: string | JSX.Element | null,
    key: any,
    where: Placement = 'top'
): JSX.Element {
    const overlay = <Tooltip id={`tooltip-${key}`}>{toolTipText}</Tooltip>
    return (
        <OverlayTrigger
            key={key}
            placement={where}
            overlay={overlay}
        >
            {item}
        </OverlayTrigger>
    )
}
